import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/components/com/layout'
import blackLayout from '@/components/com/black/layout'
import mLayout from '@/components/m/com/mLayout'
Vue.use(Router)
// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default new Router({
  mode: 'hash',
  routes: [
    /*
     ***单独报名链接
     */
    {
      path: '/signUpPc',
      name: 'signUpPc',
      component: () =>
        import("@/views/signUpPc.vue"),
    },
    /*
     ***PC端路由开始
     */
    {
      path: '/',
      name: 'home',
      component: Layout,
      children: [{
        path: '/',
        name: 'home',
        component: () =>
          import("@/views/home")
      }, ]
    },
    // 主会场
    {
      path: '/theMainVenue',
      name: 'theMainVenue',
      component: blackLayout,
      children: [{
        path: '/theMainVenue',
        name: 'theMainVenue',
        component: () =>
          import("@/views/theMainVenue")
      }, ]
    },
    // 主会场详情
    {
      path: '/theMainVenueDetails',
      component: blackLayout,
      children: [{
        path: '/theMainVenueDetails',
        name: 'theMainVenueDetails',
        component: () =>
          import("@/views/theMainVenueDetails")
      }, ]
    },
    // 分会场
    {
      path: '/branchVenue',
      name: 'branchVenue',
      component: blackLayout,
      children: [{
        path: '/branchVenue',
        name: 'branchVenue',
        component: () =>
          import("@/views/branchVenue")
      }, ]
    },
    // 分会场详情
    {
      path: '/branchVenueDetails',
      name: 'branchVenueDetails',
      component: blackLayout,
      children: [{
        path: '/branchVenueDetails',
        name: 'branchVenueDetails',
        component: () =>
          import("@/views/branchVenueDetails")
      }, ]
    },
    // 金陀螺奖
    {
      path: '/goldenTopAward',
      name: 'goldenTopAward',
      component: blackLayout,
      children: [{
        path: '/goldenTopAward',
        name: 'goldenTopAward',
        component: () =>
          import("@/views/goldenTopAward")
      }, ]
    },
    // 云展区
    {
      path: '/cloudExhibitionArea',
      name: 'cloudExhibitionArea',
      component: blackLayout,
      children: [{
        path: '/cloudExhibitionArea',
        name: 'cloudExhibitionArea',
        component: () =>
          import("@/views/cloudExhibitionArea")
      }, ]
    },
    // 大会动态
    {
      path: '/conferenceNews',
      // name: 'conferenceNews',
      component: blackLayout,
      children: [{
        path: '/conferenceNews',
        name: 'conferenceNews',
        component: () =>
          import("@/views/conferenceNews")
      }, ]
    },
    // 更多新闻
    {
      path: '/moreConferenceNews',
      name: 'moreConferenceNews',
      component: blackLayout,
      children: [{
        path: '/moreConferenceNews',
        name: 'moreConferenceNews',
        component: () =>
          import("@/views/moreConferenceNews")
      }, ]
    },
    /*
     ***PC端路由结束
     */
    /*
     *********手机端路由开始
     */
    {
      path: '/m',
      component: mLayout,
      children: [{
        path: '/',
        name: 'mHome',
        component: () =>
          import("@/views/m/mHome")
      }, ]
    },
    // 主会场
    {
      path: '/m/mTheMainVenue',
      component: mLayout,
      children: [{
        path: '/',
        name: 'mTheMainVenue',
        component: () =>
          import("@/views/m/mTheMainVenue")
      }, ]
    },
    // 主会场详情
    {
      path: '/m/mTheMainVenueDetails',
      component: mLayout,
      children: [{
        path: '/',
        name: 'mTheMainVenueDetails',
        component: () =>
          import("@/views/m/mTheMainVenueDetails")
      }, ]
    },
    // 分会场
    {
      path: '/m/mBranchVenue',
      component: mLayout,
      children: [{
        path: '/',
        name: 'mBranchVenue',
        component: () =>
          import("@/views/m/mBranchVenue")
      }, ]
    },
    // 分会场详情
    {
      path: '/m/mBranchVenueDetails',
      component: mLayout,
      children: [{
        path: '/',
        name: 'mBranchVenueDetails',
        component: () =>
          import("@/views/m/mBranchVenueDetails")
      }, ]
    },
    // 金陀螺奖
    {
      path: '/m/mGoldenTopAward',
      component: mLayout,
      children: [{
        path: '/',
        name: 'mGoldenTopAward',
        component: () =>
          import("@/views/m/mGoldenTopAward")
      }, ]
    },
    // 云展区
    {
      path: '/m/mCloudExhibitionArea',
      component: mLayout,
      children: [{
        path: '/',
        name: 'mCloudExhibitionArea',
        component: () =>
          import("@/views/m/mCloudExhibitionArea")
      }, ]
    },

    // 大会动态
    {
      path: '/m/mConferenceNews',
      component: mLayout,
      children: [{
        path: '/',
        name: 'mConferenceNews',
        component: () =>
          import("@/views/m/mConferenceNews")
      }, ]
    },
    // 更多新闻
    {
      path: '/m/mMoreConferenceNews',
      component: mLayout,
      children: [{
        path: '/',
        name: 'mMoreConferenceNews',
        component: () =>
          import("@/views/m/mMoreConferenceNews")
      }, ]
    },

    //  fbec大会微站路由开始
    // 首页
    {
      path: '/m/fbec-index',
      component: mLayout,
      children: [{
        path: '/',
        name: 'fbec-index',
        component: () =>
          import("@/views/m/quick-entrance/fbec-index")
      }, ]
    },
    // // 大会议程
    // {
    //   path: '/m/fbec-agenda',
    //   component: mLayout,
    //   children: [{
    //     path: '/',
    //     name: 'fbec-agenda',
    //     component: () =>
    //       import("@/views/m/quick-entrance/fbec-agenda")
    //   }, ]
    // },
    // // 大会动态
    // {

    //   path: '/m/fbec-dynamic',
    //   component: mLayout,
    //   children: [{
    //     path: '/',
    //     name: 'fbec-dynamic',
    //     component: () =>
    //       import("@/views/m/quick-entrance/fbec-dynamic")
    //   }, ]
    // },
    // // 参会&参展须知
    // {

    //   path: '/m/fbec-notice',
    //   component: mLayout,
    //   children: [{
    //     path: '/',
    //     name: 'fbec-notice',
    //     component: () =>
    //       import("@/views/m/quick-entrance/fbec-notice")
    //   }, ]
    // },
    // // 会场分布
    // {

    //   path: '/m/fbec-venue-distribution',
    //   component: mLayout,
    //   children: [{
    //     path: '/',
    //     name: 'fbec-venue-distribution',
    //     component: () =>
    //       import("@/views/m/quick-entrance/fbec-venue-distribution")
    //   }, ]
    // },
    // // 会场签到
    // {
    //   path: '/m/fbec-venue-sign',
    //   component: mLayout,
    //   children: [{
    //     path: '/',
    //     name: 'fbec-venue-sign',
    //     component: () =>
    //       import("@/views/m/quick-entrance/fbec-venue-sign")
    //   }, ]
    // },
    //  fbec大会微站路由结束
    /*
     *********手机端路由结束
     */
    // 大会议程
    {
      path: '/m/fbec-agenda',
      name: 'fbec-agenda',
      component: () => import("@/views/m/quick-entrance/fbec-agenda"),
      meta: {
        title: 'FBEC2021大会H5'
      }
    },
    // 大会动态
    {
      path: '/m/fbec-dynamic',
      name: 'fbec-dynamic',
      component: () => import("@/views/m/quick-entrance/fbec-dynamic"),
      meta: {
        title: 'FBEC2021大会H5'
      }
    },
    // 参会&参展须知
    {
      path: '/m/fbec-notice',
      name: 'fbec-notice',
      component: () => import("@/views/m/quick-entrance/fbec-notice"),
      meta: {
        title: 'FBEC2021大会H5'
      }
    },
    // 会场分布
    {
      path: '/m/fbec-venue-distribution',
      name: 'fbec-venue-distribution',
      component: () => import("@/views/m/quick-entrance/fbec-venue-distribution"),
      meta: {
        title: 'FBEC2021大会H5'
      }
    },
    // 会场签到
    {
      path: '/m/fbec-venue-sign',
      name: 'fbec-venue-sign',
      component: () => import("@/views/m/quick-entrance/fbec-venue-sign"),
      meta: {
        title: 'FBEC2021大会H5'
      }
    },
  ]

})



// WEBPACK FOOTER //
// ./src/router/index.js